import Axios from "../../Config/API";
import Service from "../../Service";

import { IParcelaBoletos } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import {
    IDescontos,
    IGerarNovoFluxoRequest,
    IIndicadoresParcelasRenegociacao,
    IParcelasComDescontos,
    IParcelaGeradaNovoFluxo,
    IRenegociacao,
    IValidaProdutoCasoRenegociacao,
    IValidaProdutoCasoRenegociacaoResponse,
} from "../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import {
    IFiltroModelo,
    IModeloVenda,
    IParcelaModelo,
} from "../../../Interfaces/Cobranca/Renegociacao/ModeloRenegociacao/ModeloRenegociacaoInterface";

export const CalcularDescontosRenegociacaoService = (
    idCaso: number,
    parcelas: Array<IParcelaBoletos>,
    descontos: IDescontos
) =>
    Service(
        Axios.post<Array<IParcelasComDescontos>>(
            `/cobranca/renegociacao/botaocalcular?descontoFinanceiro=${
                descontos.descontoFinanceiro ?? 0
            }&descontoPercentual=${
                descontos.descontoPercentual ?? 0
            }&descontoMultaPercentual=${
                descontos.descontoMultaPercentual ?? 0
            }&descontoJurosPercentual=${
                descontos.descontoJurosPercentual ?? 0
            }&honorarioFinanceiro=${
                descontos.honorarioFinanceiro ?? 0
            }&honorarioPercentual=${
                descontos.honorarioPercentual ?? 0
            }&idCaso=${idCaso}`,
            parcelas
        )
    );

export const CarregarModelosRenegociacaoService = (idCaso: number) =>
    Service(
        Axios.get<Array<IModeloVenda>>(
            `/cobranca/renegociacao/carregamodelonegociacao?idCaso=${idCaso}`
        )
    );

export const CarregarParcelasModeloRenegociacaoService = (
    idModelo: number,
    DiaPrimeiraParc: number,
    indicadores: IIndicadoresParcelasRenegociacao,
    valorEntrada?: number,
    dtEntrada?: string
) =>
    Service(
        Axios.post<Array<IParcelaModelo>>(
            `/cobranca/renegociacao/carregaparcelasmodelonegociacao?idModelo=${idModelo}`,
            {
                ValorContrato: indicadores.VL_CONTRATO,
                ValorCustas: indicadores.VL_CUSTAS,
                ValorSeguro: indicadores.VL_SEGURO,
                ValorHonorario: indicadores.VL_HONORARIO,
                ValorTotal: indicadores.VL_TOTAL,
                ValorEntrada: valorEntrada,
                DataVencimentoEntrada: dtEntrada,
                DiaPrimeiraParc: DiaPrimeiraParc,
            }
        )
    );

export const CalcularNovoFluxoService = (
    parcelas: Array<IParcelaModelo>,
    request: IGerarNovoFluxoRequest
) =>
    Service(
        Axios.post<Array<IParcelaGeradaNovoFluxo>>(
            `/cobranca/renegociacao/calculanovofluxo?idCaso=${request.idCaso}&idModelo=${request.idModelo}&ValorContrato=${request.valores.VL_CONTRATO}&ValorCustas=${request.valores.VL_CUSTAS}&ValorSeguro=${request.valores.VL_SEGURO}&ValorHonorario=${request.valores.VL_HONORARIO}&ValorTotal=${request.valores.VL_TOTAL}&DiaPrimeiraParc=${request.DiaPrimeiraParc}`,
            parcelas
        )
    );

export const FinalizarAcordoRenegociacaoService = (
    renegociacaoConfig: IRenegociacao,
    renegociacaoFiltro: IFiltroModelo
) =>
    Service(
        Axios.post(
            `/cobranca/renegociacao/finalizaracordo?ValorContrato=${renegociacaoFiltro.ValorContrato}&ValorCustas=${renegociacaoFiltro.ValorCustas}&ValorSeguro=${renegociacaoFiltro.ValorSeguro}&ValorHonorario=${renegociacaoFiltro.ValorHonorario}&DataVencimentoEntrada=${renegociacaoFiltro.DataVencimentoEntrada}&ValorEntrada=${renegociacaoFiltro.ValorEntrada}&ValorTotal=${renegociacaoFiltro.ValorTotal}&DiaPrimeiraParc=${renegociacaoFiltro.DiaPrimeiraParc}`,
            renegociacaoConfig
        )
    );

export const ValidaProdutoECasoParaRenegociacaoService = (
    validaReneg: IValidaProdutoCasoRenegociacao
) =>
    Service(
        Axios.post<IValidaProdutoCasoRenegociacaoResponse>(
            `/cobranca/renegociacao/validavendamanutencao?ID_CHAVE_ERP=${validaReneg.ID_CHAVE_ERP}&ID_CASO=${validaReneg.ID_CASO}`,
            validaReneg
        )
    );
